import React from 'react';
import { motion } from 'framer-motion';
type Props = {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
};
export function CtaButton({
  children,
  href = '#planes',
  onClick,
  className = '',
  fullWidth = true
}: Props) {
  return <motion.a href={href} onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.97
  }} className={`group inline-flex min-h-11 items-center justify-center gap-2 rounded-full bg-ink px-5 py-3 text-center font-sans text-xs font-semibold uppercase tracking-wider text-cream shadow-lg shadow-plum/20 transition-colors hover:bg-plum sm:px-8 sm:py-4 sm:text-sm ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-302" data-mp="20u285romqmbl">
      {children}
    </motion.a>;
}